import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Text,
  VStack,
} from '@chakra-ui/react';

interface AchieveRockModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Achieve Rock Modal Component
 * Confirmation modal for marking a rock as achieved
 * Migrated from Tailwind to Chakra UI
 */
export function AchieveRockModal({ isOpen, onClose, onConfirm }: AchieveRockModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Mark Rock as Achieved</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="stretch">
            <Text>Are you sure you want to mark this rock as achieved?</Text>
            <Text fontSize="sm" color="gray.600">
              This will set the rock's progress to 100% and mark it as achieved.
            </Text>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button colorScheme="green" onClick={onConfirm}>
            Mark as Achieved
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

